// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import AppsLauncherProperties from './data'

export default function AppsLauncherPropertiesFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/AppsLauncherProperties">
      <AppsLauncherProperties {...props}>
        {children}
      </AppsLauncherProperties>
    </Flow>
  )
}
